document.addEventListener("DOMContentLoaded", function () {
  // إنشاء كائن Fabric.js للرسم داخل الغرفة
  const canvas = new fabric.Canvas("room-canvas", {
    width: 800,
    height: 500,
    backgroundColor: "#f0f0f0",
  });

  // تفعيل سحب الأثاث
  document.querySelectorAll(".furniture-item").forEach((item) => {
    item.addEventListener("click", function () {
      let imgURL = this.getAttribute("data-image");

      fabric.Image.fromURL(imgURL, function (img) {
        img.scale(0.5);
        img.set({ left: 100, top: 100, hasControls: true });
        canvas.add(img);
      });
    });
  });
});
